









import { Vue, Component, PropSync } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';

@Component
export default class Left extends Vue {
  @PropSync('menu') menuSync!: any[];
  @State MENU_INDENT: any;

  created() {}

  update(key: string) {
    this.$emit('update', key);
  }
}
